import React from 'react';

// Types
import { EmptyStateProps } from '../../types/display/emptyState';

// Components
import { Icon } from './Icon';

export const EmptyState = ({ icon, title, children }: EmptyStateProps) => (
  <article className="empty-state">
    <header className="empty-state__hero">
      <Icon icon={icon} size="3x" />
    </header>
    <div className="flow">
      <h2 className="h3">{title}</h2>
      <small className="text-muted">{children}</small>
    </div>
  </article>
);
